import {combineReducers} from 'redux';
import data from './dataReducers';
import view from './pageReducer';

export default combineReducers({
  data,
  view,
});
